import axios from './auth'

const COMPANY_BASE_URL = `${process.env.VUE_APP_API_OPS_BASE_URL}/companies`;

export const state = {}

export const getters = {}

export const mutations = {}

export const actions = {
  async getCompanies({ commit }, params = {}) {
    const url = COMPANY_BASE_URL;

    const method = "get";
    const headers = {};
    const config = {
      url,
      method,
      headers,
      params
    };

    try {
      const response = await axios(config);
      let data = response.data.data;
      return {
        status: 'success',
        data,
      };
    } catch (e) {
      return {
        status: 'error',
        data: e.response.data
      };
    }
  },
}
